import React, { useReducer, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ImageSelectors from "../../../Component/DigitalMarketing/ImageSelectors";
import { ProfileLabel } from "./Utils";
import { Button } from "@mui/material";
import { validateEmail } from "../../../utils";
import { validatePhone } from "../Customer/Utils/validation";
import {
  useGetTemplateImageQuery,
  useGetUserProfileDetailsQuery,
  useUpdateTemplateImageMutation,
  useUpdateUserProfileMutation,
} from "../../../Service/settings";
import PermissionCheck from "../../../Component/PermissionCheck";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { FaCircle } from "react-icons/fa";

function Template(props) {
  const { openSnackBar } = props;
  const initialState = {
    templateImage: "",
  };
  const [selectedImage, setSelectedImage] = useState(null);
  const [profile, setProfile] = useState<any>(initialState);
  const [updateTemplateImage,{ isLoading:updateLoading }] = useUpdateTemplateImageMutation();
  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);
  const response = useGetTemplateImageQuery(reducerValue, {
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    response?.data && setProfile(response?.data);
  }, [response?.data]);

  // console.log(profile);

  const onHandleChange = (event) => {
    const { name, value, files } = event.target;
    // console.log(value);
    // console.log(name);
    
    setProfile((prevState) => ({ ...prevState, [name]: value }));
  };
  const onSave = async () => {
    var form_data = new FormData();
    for (var key in profile) {
      if (key === "templateImage") {
        form_data.append(key, profile[key]);
      }
    }
    try {
      const payload = await updateTemplateImage(form_data).unwrap();
      openSnackBar("Updated successfully");
      forceUpdate();
    } catch (error: any) {
      openSnackBar(error.data.error, "error");
    }
  };

  return (
    <Row className="mt-4 mx-3">
      <Col md={5} className="mb-3">
        <div className="template d-flex">
          <ImageSelectors
            setSelectedImage={setSelectedImage}
            existingImage={selectedImage || profile?.templateImage}
            classes="setting-img"
            key_name="templateImage"
            handleChange={onHandleChange}
            openSnackBar={openSnackBar}
            icon ={true}
          />
        </div>
      </Col>
      <Col
        md={7}
        className="d-flex justify-content-center align-items-center password-rules mb-3"
      >
        <div>
          <ul className="grey">
            <li>
              <p className="black">Template Image Requirments</p>
            </li>
            <li>
              <FaCircle className="blue-circle" />
              Resolution: 563*560
            </li>
            <li>
              <FaCircle className="blue-circle" />
             Image format: JPEG, PNG 
            </li>
            <li>
              <FaCircle className="blue-circle" />
              size not exceeding 400kb            </li>
          </ul>
        </div>
      </Col>
        <Col md={12} className="mt-4">
          <div>
            <Button
              variant="outlined"
              className="me-2"
              onClick={() => {
                setSelectedImage(null);
                forceUpdate();
              }}
              id="btn-outline"
            >
              Cancel
            </Button>
            <Button variant="contained" disabled={updateLoading} id="btn-add" onClick={onSave}>
              {updateLoading?"Wait":"Update"}
            </Button>
          </div>
        </Col>
    </Row>
  );
}

export default Template;
